export const environment = {
  production: false,
  apiUrl: 'https://api-miglm-beta.azurewebsites.net',
  miUrl: 'https://mi.glm.edu.co'
};
